import React from "react";
import HeroSection from "../../components/home/HeroSection";
import AiDrivenInsights from "../../components/home/AiDrivenInsights";
import FirstBanner from "../../components/home/FirstBanner";
import WhoWeAre from "../../components/home/WhoWeAre";
import Services from "../../components/home/Services";
import ImageContainer from "../../components/home/ImageContainer";
import UnifiedCloudSolutions from "../../components/home/UnifiedCloudSolutions";
import Achievement from "../../components/home/Achievement";
import Articles from "../../components/home/Articles";
import DatoulaBanner from "../../components/home/DatoulaBanner";
import FAQs from "../../components/home/FAQs";
import PartnerBanner from "../../components/home/PartnerBanner";

const Home = () => (
  <>
    <HeroSection />
    <AiDrivenInsights />
    <FirstBanner />
    <WhoWeAre />
    <Services />
    <ImageContainer />
    <UnifiedCloudSolutions />
    <Achievement />
    <Articles />
    <DatoulaBanner />
    <FAQs />
    <PartnerBanner />
  </>
);

export default Home;
